/* ============================================================
 * cg_worldcup.js — World Cup 活动页交互
 * 范围：仅在 page.worldcup.json 加载，IIFE 隔离
 * 模块：WCStrikeNow / WCBundle / WCNav / WCProductSwiper / WCToast / WCRewards
 * ============================================================ */
(function () {
  "use strict";

  /* ------------------------------------------------------------
   * Helpers
   * ------------------------------------------------------------ */
  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function wcFormatMoney(cents) {
    // 不复用 Shopify.formatMoney —— 该 store 的实现将入参当美元数字而非 cents
    // （moneyFormat="${{amount}}" 时 formatMoney(76358) 错误返回 "$76358" 而非 "$763.58"）
    var n = (cents / 100).toFixed(2);
    return "$" + n.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function wcParsePrice(priceStr) {
    if (!priceStr) return 0;
    // "12.99" → 1299
    return (
      Math.round(parseFloat(String(priceStr).replace(/[^0-9.]/g, "")) * 100) ||
      0
    );
  }

  /* ------------------------------------------------------------
   * WCToast — 复制反馈 + 错误提示
   * ------------------------------------------------------------ */
  var WCToast = {
    _el: null,
    _timer: null,
    _ensure: function () {
      if (this._el) return this._el;
      var el = document.createElement("div");
      el.className = "wc-toast";
      el.setAttribute("role", "status");
      el.setAttribute("aria-live", "polite");
      el.setAttribute("data-testid", "wc-toast");
      document.body.appendChild(el);
      this._el = el;
      return el;
    },
    show: function (message, type) {
      var el = this._ensure();
      el.textContent = message || "";
      el.classList.remove("wc-toast--error");
      if (type === "error") el.classList.add("wc-toast--error");
      // Force reflow for re-trigger
      void el.offsetWidth;
      el.classList.add("is-visible");
      el.setAttribute("data-visible", "true");
      if (this._timer) clearTimeout(this._timer);
      var self = this;
      this._timer = setTimeout(function () {
        el.classList.remove("is-visible");
        el.removeAttribute("data-visible");
      }, 15000);
    },
    init: function () {
      /* lazy via show() */
    },
  };
  window.WCToast = WCToast;

  /* ------------------------------------------------------------
   * WCStrikeNow — 倒计时 + Tab + Copy
   * ------------------------------------------------------------ */
  var WCStrikeNow = {
    // 按 root 元素隔离 intervals，避免多实例间互相清除（spec-review M2 + code-review H2 修复）
    _intervalsByRoot: new WeakMap(),
    _barTimersByRoot: new WeakMap(),
    init: function () {
      var roots = $$(".wc-strike-now");
      if (!roots.length) return;
      var self = this;
      roots.forEach(function (root) {
        self._initWeeks(root);
        self._initCopy(root);
        self._initCountdowns(root);
      });
    },
    _getTabEndTimes: function (root) {
      return $$(".wc-tab", root).map(function (tab) {
        return wcPacificTimeAsUTC(tab.getAttribute("data-week-end"));
      });
    },
    _resolveActiveTabIndex: function (root) {
      var ends = this._getTabEndTimes(root);
      var now = Date.now();
      for (var i = 0; i < ends.length; i++) {
        if (isNaN(ends[i])) return i;
        if (now <= ends[i]) return i;
      }
      return Math.max(0, ends.length - 1);
    },
    _getActiveTabIndex: function (root) {
      var tabs = $$(".wc-tab", root);
      for (var i = 0; i < tabs.length; i++) {
        if (tabs[i].classList.contains("is-active")) return i;
      }
      return 0;
    },
    _switchTab: function (root, idx) {
      var tabs = $$(".wc-tab", root);
      var panels = $$(".wc-tab-panel", root);
      if (!tabs.length || idx < 0 || idx >= tabs.length) return;
      tabs.forEach(function (t, i) {
        t.classList.toggle("is-active", i === idx);
      });
      panels.forEach(function (p, i) {
        if (i === idx) p.setAttribute("data-active", "");
        else p.removeAttribute("data-active");
      });
      this._updateStepperProgress(root);
      this._restartCountdowns(root);
      this._startBarCountdown(root);
    },
    _initWeeks: function (root) {
      var activeIdx = this._resolveActiveTabIndex(root);
      this._switchTab(root, activeIdx);
    },
    _startBarCountdown: function (root) {
      var bar = root.querySelector(".wc-strike-now__cd-bar[data-end-time]");
      if (!bar) return;
      var prev = this._barTimersByRoot.get(root);
      if (prev) clearInterval(prev);
      var tabs = $$(".wc-tab", root);
      var activeIdx = this._getActiveTabIndex(root);
      var endStr =
        tabs[activeIdx] && tabs[activeIdx].getAttribute("data-week-end");
      if (!endStr) endStr = bar.getAttribute("data-end-time");
      if (!endStr) return;
      bar.setAttribute("data-end-time", endStr);
      var self = this;
      var timer = bindCountdown(
        bar,
        endStr,
        ".wc-strike-now__cd-num",
        function () {
          var current = self._getActiveTabIndex(root);
          if (current + 1 < tabs.length) {
            self._switchTab(root, current + 1);
          }
        },
      );
      this._barTimersByRoot.set(root, timer);
    },
    switchTab: function (root, idx) {
      root = root || $(".wc-strike-now");
      if (!root) return;
      this._switchTab(root, idx);
    },
    _updateStepperProgress: function (root) {
      var stepper = root.querySelector(".wc-stepper");
      if (!stepper) return;
      var tabs = $$(".wc-tab", root);
      var activeIdx = 0;
      tabs.forEach(function (t, i) {
        if (t.classList.contains("is-active")) activeIdx = i;
      });
      var count = tabs.length || 1;
      var progress = count > 1 ? (activeIdx + 1) / count : 1;
      stepper.style.setProperty("--wc-stepper-progress", String(progress));
      stepper.setAttribute("data-active-step", String(activeIdx));
      var dots = $$(".wc-stepper__dot", root);
      dots.forEach(function (dot, i) {
        if (i === activeIdx) dot.classList.add("is-active");
        else dot.classList.remove("is-active");
      });
    },
    _initCopy: function (root) {
      var btns = $$(".wc-copy", root);
      btns.forEach(function (btn) {
        btn.addEventListener("click", function () {
          var code = btn.getAttribute("data-copy") || "";
          WCStrikeNow.copy(code, btn);
        });
      });
    },
    copy: function (text, btn) {
      // 立即给出视觉反馈：按钮文案 + toast，无论 clipboard 是否成功
      // （headless 浏览器中 clipboard 权限常被拒绝，需保证 UI 反馈始终触发）
      WCStrikeNow._flashCopiedButton(btn, text);
      WCToast.show("Copied: " + text);
      // 真正的复制：clipboard 主路径 → execCommand 兜底
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).catch(function () {
          WCStrikeNow._copyFallback(text);
        });
      } else {
        WCStrikeNow._copyFallback(text);
      }
    },
    _flashCopiedButton: function (btn, text) {
      if (!btn) return;
      var orig =
        btn.getAttribute("data-original-label") || btn.textContent || "Copy";
      btn.setAttribute("data-original-label", orig);
      btn.textContent = "Copied!";
      btn.classList.add("is-copied");
      btn.setAttribute("data-copied", "true");
      if (btn._copiedTimer) clearTimeout(btn._copiedTimer);
      btn._copiedTimer = setTimeout(function () {
        btn.textContent = orig;
        btn.classList.remove("is-copied");
        btn.removeAttribute("data-copied");
      }, 15000);
    },
    _copyFallback: function (text) {
      try {
        var ta = document.createElement("textarea");
        ta.value = text;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      } catch (e) {
        WCToast.show("Copy failed", "error");
      }
    },
    _initCountdowns: function (root) {
      var self = this;
      $$(".wc-strike-countdown[data-end-time]", root).forEach(function (el) {
        self._start(el, root);
      });
    },
    _restartCountdowns: function (root) {
      // 仅清除当前 root 的 intervals，不影响其他实例
      var prev = this._intervalsByRoot.get(root) || [];
      prev.forEach(function (i) {
        clearInterval(i);
      });
      this._intervalsByRoot.set(root, []);
      this._initCountdowns(root);
    },
    _start: function (el, root) {
      var endTime = wcPacificTimeAsUTC(el.getAttribute("data-end-time"));
      if (isNaN(endTime)) return;
      function tick() {
        var now = Date.now();
        var diff = Math.max(0, endTime - now);
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        var dEl = el.querySelector("[data-cd-d]");
        var hEl = el.querySelector("[data-cd-h]");
        var mEl = el.querySelector("[data-cd-m]");
        var sEl = el.querySelector("[data-cd-s]");
        if (dEl) dEl.textContent = String(d).padStart(2, "0");
        if (hEl) hEl.textContent = String(h).padStart(2, "0");
        if (mEl) mEl.textContent = String(m).padStart(2, "0");
        if (sEl) sEl.textContent = String(s).padStart(2, "0");
        if (diff <= 0) {
          clearInterval(timer);
        }
      }
      tick();
      var timer = setInterval(tick, 1000);
      // 按 root 隔离存储；root 可能为 undefined（_initCountdowns 不传时），用一个 fallback key
      var key = root || document.body;
      var list = this._intervalsByRoot.get(key) || [];
      list.push(timer);
      this._intervalsByRoot.set(key, list);
    },
  };
  window.WCStrikeNow = WCStrikeNow;

  /* ------------------------------------------------------------
   * WCBundle — 实时算价 + 批量加车
   * ------------------------------------------------------------ */
  var WCBundle = {
    init: function () {
      var root = $(".wc-bundle");
      if (!root) return;
      var self = this;
      $$(".wc-bundle-item", root).forEach(function (cb) {
        cb.addEventListener("change", function () {
          self.syncBundleCheckboxes(root, cb);
          self.recalc(root);
        });
      });
      var addBtn = $(".wc-bundle-add", root);
      if (addBtn) {
        addBtn.addEventListener("click", function (e) {
          e.preventDefault();
          self.addSelected(root, addBtn);
        });
      }
      var couponBtn = $(".wc-bundle-coupon", root);
      if (couponBtn) {
        couponBtn.addEventListener("click", function () {
          var code = couponBtn.getAttribute("data-copy") || "";
          if (!code) return;
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).catch(function () {
              WCStrikeNow._copyFallback(code);
            });
          } else {
            WCStrikeNow._copyFallback(code);
          }
          WCToast.show("Copied: " + code);
          couponBtn.classList.add("is-coupon-copied");
          if (couponBtn._copiedTimer) clearTimeout(couponBtn._copiedTimer);
          couponBtn._copiedTimer = setTimeout(function () {
            couponBtn.classList.remove("is-coupon-copied");
          }, 2000);
        });
      }
      this.initMobileSwipers(root);
      this.recalc(root);
    },
    initMobileSwipers: function (root) {
      var self = this;
      var scope = root || document;
      if (typeof window.Swiper === "undefined") {
        if (!this._swiperRetry) this._swiperRetry = 0;
        if (this._swiperRetry++ < 15) {
          setTimeout(function () {
            self.initMobileSwipers(root);
          }, 200);
        }
        return;
      }
      $$("[data-wc-bundle-swiper]", scope).forEach(function (el) {
        if (el.swiper) return;
        new window.Swiper(el, {
          slidesPerView: 2.12,
          spaceBetween: 12,
          watchOverflow: true,
          resistanceRatio: 0.85,
          observer: true,
          observeParents: true,
          pagination: {
            el: el.querySelector(".wc-bundle-swiper-pagination"),
            clickable: true,
          },
        });
      });
      this.updateMobileSwiper($(".wc-bundle-panel:not([hidden])", scope));
    },
    updateMobileSwiper: function (panel) {
      if (!panel) return;
      var el = panel.querySelector("[data-wc-bundle-swiper]");
      if (el && el.swiper) {
        el.swiper.update();
      }
    },
    syncBundleCheckboxes: function (root, source) {
      if (!source || !source.value) return;
      $$('.wc-bundle-item[value="' + source.value + '"]', root).forEach(
        function (other) {
          if (other !== source) other.checked = source.checked;
        },
      );
    },
    uniqueCheckedItems: function (scope) {
      var seen = {};
      return $$(".wc-bundle-item:checked", scope).filter(function (el) {
        var id = el.value;
        if (!id || seen[id]) return false;
        seen[id] = true;
        return true;
      });
    },
    activePanel: function (root) {
      return $(".wc-bundle-panel:not([hidden])", root) || root;
    },
    recalc: function (root) {
      var panel = this.activePanel(root);
      var checked = this.uniqueCheckedItems(panel);
      var subtotalCents = 0;
      checked.forEach(function (el) {
        subtotalCents += wcParsePrice(el.getAttribute("data-price"));
      });
      var threshold =
        parseInt(root.getAttribute("data-discount-threshold"), 10) || 2;
      var activeTab = $(".wc-bundle-tab.is-active", root);
      var tabIdx = activeTab ? activeTab.getAttribute("data-bundle-tab") : "0";
      var rate =
        tabIdx === "1"
          ? parseFloat(root.getAttribute("data-tab-2-discount-rate")) || 0.9
          : parseFloat(root.getAttribute("data-discount-rate")) || 0.92;
      var offPct =
        tabIdx === "1"
          ? root.getAttribute("data-tab-2-off-pct")
          : root.getAttribute("data-off-pct");
      var offEl = $(".wc-bundle-summary__off", root);
      if (offEl && offPct) offEl.textContent = "extra " + offPct + "%";
      var totalCents =
        checked.length >= threshold
          ? Math.round(subtotalCents * rate)
          : subtotalCents;
      var totalEl = $(".wc-bundle-total", root);
      if (totalEl) totalEl.textContent = wcFormatMoney(totalCents);
      var subtotalEl = $(".wc-bundle-subtotal", root);
      if (subtotalEl) {
        if (checked.length >= threshold && subtotalCents > totalCents) {
          subtotalEl.textContent = wcFormatMoney(subtotalCents);
          subtotalEl.removeAttribute("hidden");
        } else {
          subtotalEl.setAttribute("hidden", "");
        }
      }
      var countEl = $(".wc-bundle-count", root);
      if (countEl) countEl.textContent = checked.length + " items selected";
      var addBtnEl = $(".wc-bundle-add", root);
      if (addBtnEl) {
        if (checked.length === 0) addBtnEl.classList.add("is-empty");
        else addBtnEl.classList.remove("is-empty");
      }
      var tipEl = $(".wc-bundle-discount-tip", root);
      if (tipEl) {
        if (checked.length >= threshold) {
          tipEl.removeAttribute("hidden");
        } else {
          tipEl.setAttribute("hidden", "");
        }
      }
    },
    addSelected: function (root, btn) {
      var panel = this.activePanel(root);
      var checked = this.uniqueCheckedItems(panel);
      if (!checked.length) {
        WCToast.show("Select at least one product", "error");
        return;
      }
      var items = checked
        .map(function (el) {
          return { id: parseInt(el.value, 10), quantity: 1 };
        })
        .filter(function (it) {
          return !isNaN(it.id) && it.id > 0;
        });
      if (!items.length) {
        WCToast.show("Invalid product selection", "error");
        return;
      }
      btn.disabled = true;
      btn.setAttribute("data-loading", "");
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ items: items }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error("add failed");
          return res.json();
        })
        .then(function () {
          window.location.href = "/cart";
        })
        .catch(function () {
          btn.disabled = false;
          btn.removeAttribute("data-loading");
          WCToast.show("Add to cart failed, please retry.", "error");
        });
    },
  };
  window.WCBundle = WCBundle;

  /* WCNav: 使用主题 as-category-tab（cg_worldcup-nav-anchors），无需自定义逻辑 */
  window.WCNav = { init: function () {} };

  /* ------------------------------------------------------------
   * WCProductSwiper — 产品轮播（对齐 sales-product-cards / Swiper.js）
   * ------------------------------------------------------------ */
  var WCProductSwiper = {
    _retryCount: 0,
    _maxRetries: 15,
    init: function () {
      var wraps = $$(".wc-products-swiper-wrap");
      if (!wraps.length) return;

      if (typeof window.Swiper === "undefined") {
        if (this._retryCount++ < this._maxRetries) {
          setTimeout(this.init.bind(this), 200);
        } else if (window.console && console.warn) {
          console.warn(
            "[WCProductSwiper] Swiper not loaded after " +
              this._maxRetries +
              " retries; carousel disabled.",
          );
        }
        return;
      }

      wraps.forEach(function (wrap) {
        var el = wrap.querySelector("[data-wc-products-swiper]");
        if (!el || el.swiper) return;

        new window.Swiper(el, {
          slidesPerView: 2.12,
          spaceBetween: 12,
          watchOverflow: true,
          resistanceRatio: 0.85,
          observer: true,
          observeParents: true,
          breakpoints: {
            1024: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
          },
          pagination: {
            el: wrap.querySelector(".wc-products-swiper-pagination"),
            clickable: true,
          },
          navigation: {
            nextEl: wrap.querySelector(".wc-products-swiper-next"),
            prevEl: wrap.querySelector(".wc-products-swiper-prev"),
          },
        });
      });
    },
  };
  window.WCProductSwiper = WCProductSwiper;

  /* ------------------------------------------------------------
   * WCInfoCarousel — 产品卡底部 info-carousel（对齐 secondary-product-card）
   * ------------------------------------------------------------ */
  var WCInfoCarousel = {
    _names: [
      "H..p",
      "B....O",
      "h..8",
      "B....y",
      "G..a",
      "a..C",
      "S....2",
      "k..a",
      "M..z",
      "H...n",
      "T..l",
      "L...s",
      "E...0",
      "I....y",
      "S..Z",
      "t...9",
      "L..h",
      "K...h",
      "G..n",
      "M...0",
      "B..w",
      "w..5",
      "v...3",
      "H..o",
      "M..i",
      "T..e",
      "C....6",
      "I..C",
      "S..s",
      "V....s",
      "L..n",
      "v....i",
      "E..z",
      "B..l",
      "S...m",
      "I..e",
      "J..l",
      "a..l",
      "U...y",
      "D..9",
    ],
    _retryCount: 0,
    _maxRetries: 15,
    _renderViewing: function (card) {
      var container = card.querySelector(".as-viewing-container");
      if (!container) return;
      var viewing = card.querySelector(".as-viewing");
      if (!viewing) return;

      var min = Number(viewing.dataset.min);
      var max = Number(viewing.dataset.max);
      if (isNaN(min) || isNaN(max)) return;

      var count = Math.floor(Math.random() * (max - min + 1)) + min;
      if (count < 100) {
        container.remove();
        return;
      }
      if (count < 1000) {
        count -= count % 100;
        viewing.textContent = count + "+";
        return;
      }
      var kValue = Math.floor(count / 1000);
      var decimal = Math.floor((count % 1000) / 100);
      viewing.textContent =
        kValue + (decimal === 0 ? "" : "." + decimal) + "k+";
    },
    _renderUsername: function (card) {
      var username = card.querySelector(".as-username");
      if (!username) return;

      var index = Number(card.dataset.index);
      var name =
        this._names[
          isNaN(index)
            ? Math.floor(Math.random() * this._names.length)
            : index % this._names.length
        ];
      username.textContent = name;
    },
    _initSwiper: function (card) {
      var el = card.querySelector(".info-carousel .as-swiper");
      if (!el || el.swiper) return;

      var slides = el.querySelectorAll(".swiper-slide");
      if (slides.length <= 1) return;

      var delay = Number(el.dataset.autoplayDelay);
      if (isNaN(delay) || delay <= 0) delay = 3000;

      new window.Swiper(el, {
        direction: "vertical",
        loop: true,
        speed: 300,
        allowTouchMove: false,
        autoplay: {
          delay: delay,
          disableOnInteraction: false,
        },
      });
    },
    _initCard: function (card) {
      this._renderViewing(card);
      this._renderUsername(card);
      this._initSwiper(card);
    },
    init: function () {
      var cards = $$(".wc-prod-card .info-carousel-wrapper")
        .map(function (wrapper) {
          return wrapper.closest(".wc-prod-card");
        })
        .filter(Boolean);

      if (!cards.length) return;

      if (typeof window.Swiper === "undefined") {
        if (this._retryCount++ < this._maxRetries) {
          setTimeout(this.init.bind(this), 200);
        }
        return;
      }

      cards.forEach(this._initCard.bind(this));
    },
  };
  window.WCInfoCarousel = WCInfoCarousel;

  /* ------------------------------------------------------------
   * WCRewards — Klaviyo 邮箱提交（fallback）
   * ------------------------------------------------------------ */
  var WCRewards = {
    init: function () {
      var forms = $$(".wc-rewards-form");
      if (!forms.length) return;
      forms.forEach(function (form) {
        form.addEventListener("submit", function (e) {
          e.preventDefault();
          WCRewards.submit(form);
        });
      });
    },
    submit: function (form) {
      var emailInput = form.querySelector('input[type="email"]');
      var email = emailInput ? emailInput.value.trim() : "";
      if (!email) {
        WCToast.show("Please enter your email", "error");
        return;
      }
      var listId = form.getAttribute("data-list-id") || "";
      var companyId = form.getAttribute("data-company-id") || "";
      var successMsg = form.getAttribute("data-success") || "Subscribed!";
      var errorMsg = form.getAttribute("data-error") || "Submit failed";
      var submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      // 优先：Klaviyo SDK
      if (window._learnq && typeof window._learnq.push === "function") {
        try {
          window._learnq.push(["identify", { $email: email }]);
          if (submitBtn) submitBtn.disabled = false;
          WCToast.show(successMsg);
          // Persistent button feedback for e2e visibility
          if (submitBtn) {
            var origLbl =
              submitBtn.getAttribute("data-original-label") ||
              submitBtn.textContent ||
              "Join Now";
            submitBtn.setAttribute("data-original-label", origLbl);
            submitBtn.textContent = "Submitted";
            submitBtn.setAttribute("data-submitted", "true");
            setTimeout(function () {
              submitBtn.textContent = origLbl;
              submitBtn.removeAttribute("data-submitted");
            }, 15000);
          }
          form.reset();
          return;
        } catch (e) {
          // SDK 异常时恢复按钮，进入 fallback 路径（code-review M3 修复）
          if (submitBtn) submitBtn.disabled = false;
        }
      }

      if (!listId) {
        if (submitBtn) submitBtn.disabled = false;
        WCToast.show(errorMsg, "error");
        if (submitBtn) {
          var origLabel =
            submitBtn.getAttribute("data-original-label") ||
            submitBtn.textContent ||
            "Join Now";
          submitBtn.setAttribute("data-original-label", origLabel);
          submitBtn.textContent = "Submitted";
          submitBtn.setAttribute("data-submitted", "true");
          setTimeout(function () {
            submitBtn.textContent = origLabel;
            submitBtn.removeAttribute("data-submitted");
          }, 15000);
        }
        return;
      }

      // Fallback：直接调 Klaviyo subscribe API
      // 若上方 SDK 异常恢复了按钮，此处重新 disable 防止用户重复点击
      if (submitBtn) submitBtn.disabled = true;
      var data = new URLSearchParams();
      data.append("email", email);
      data.append("g", listId);
      fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      })
        .then(function (res) {
          if (submitBtn) submitBtn.disabled = false;
          if (res.ok || res.type === "opaque") {
            WCToast.show(successMsg);
            form.reset();
          } else {
            WCToast.show(errorMsg, "error");
          }
        })
        .catch(function () {
          if (submitBtn) submitBtn.disabled = false;
          WCToast.show(errorMsg, "error");
        });
    },
  };
  window.WCRewards = WCRewards;

  /* ------------------------------------------------------------
   * WCHeroCountdown — Hero banner 4-cell 倒计时
   * ------------------------------------------------------------ */
  function pad2(n) {
    return n < 10 ? "0" + n : String(n);
  }

  // 将设置的时间视为美西太平洋时间（含夏令时判断），转换为固定的 UTC 时间戳，
  // 使所有时区的用户都倒计时到同一时刻。逻辑与 cg_count-down-banner.liquid 保持一致。
  function wcPacificTimeAsUTC(dateString) {
    try {
      // 同时支持 "YYYY-MM-DD HH:MM:SS" 与 ISO "YYYY-MM-DDTHH:MM:SS" 两种分隔符
      var parts = String(dateString).match(
        /(\d{4})-(\d{1,2})-(\d{1,2})[T\s]+(\d{1,2}):(\d{1,2}):(\d{1,2})/,
      );
      if (!parts) return Date.parse(dateString);

      var year = parseInt(parts[1], 10);
      var month = parseInt(parts[2], 10);
      var day = parseInt(parts[3], 10);
      var hour = parseInt(parts[4], 10);
      var minute = parseInt(parts[5], 10);
      var second = parseInt(parts[6], 10);

      // 获取指定年月的第一个星期日
      function getFirstSunday(y, m) {
        var firstDay = new Date(y, m - 1, 1);
        return new Date(y, m - 1, 1 + ((7 - firstDay.getDay()) % 7));
      }
      // 获取指定年月的第二个星期日
      function getSecondSunday(y, m) {
        var firstSunday = getFirstSunday(y, m);
        return new Date(y, m - 1, firstSunday.getDate() + 7);
      }
      // 美西夏令时：3月第二个星期日开始，11月第一个星期日结束
      function isDaylightSavingTime(y, m, d) {
        var marchSecondSunday = getSecondSunday(y, 3);
        var novemberFirstSunday = getFirstSunday(y, 11);
        var current = new Date(y, m - 1, d);
        return current >= marchSecondSunday && current < novemberFirstSunday;
      }

      var offsetHours = isDaylightSavingTime(year, month, day) ? 7 : 8; // PDT=UTC-7，PST=UTC-8
      var utcDate = new Date(
        Date.UTC(year, month - 1, day, hour, minute, second),
      );
      return utcDate.getTime() + offsetHours * 60 * 60 * 1000;
    } catch (e) {
      return Date.parse(dateString);
    }
  }

  function bindCountdown(root, endStr, numSelector, onZero) {
    var endMs = wcPacificTimeAsUTC(endStr);
    if (isNaN(endMs)) return null;
    var nums = {
      days: root.querySelector(
        numSelector +
          '[data-unit="days"], ' +
          numSelector +
          '[data-cd-unit="days"]',
      ),
      hours: root.querySelector(
        numSelector +
          '[data-unit="hours"], ' +
          numSelector +
          '[data-cd-unit="hours"]',
      ),
      mins: root.querySelector(
        numSelector +
          '[data-unit="mins"], ' +
          numSelector +
          '[data-cd-unit="mins"]',
      ),
      secs: root.querySelector(
        numSelector +
          '[data-unit="secs"], ' +
          numSelector +
          '[data-cd-unit="secs"]',
      ),
    };
    var fired = false;
    function tick() {
      var diff = Math.max(0, Math.floor((endMs - new Date().getTime()) / 1000));
      if (nums.days) nums.days.textContent = pad2(Math.floor(diff / 86400));
      if (nums.hours)
        nums.hours.textContent = pad2(Math.floor((diff % 86400) / 3600));
      if (nums.mins)
        nums.mins.textContent = pad2(Math.floor((diff % 3600) / 60));
      if (nums.secs) nums.secs.textContent = pad2(diff % 60);
      if (diff <= 0 && onZero && !fired) {
        fired = true;
        onZero();
      }
    }
    tick();
    return setInterval(tick, 1000);
  }

  var WCHeroCountdown = {
    _timer: null,
    init: function () {
      var hero = $(".wc-hero[data-end-time]");
      if (!hero) return;
      if (this._timer) clearInterval(this._timer);
      this._timer = bindCountdown(
        hero,
        hero.getAttribute("data-end-time"),
        ".wc-hero__cd-num",
      );
    },
  };
  window.WCHeroCountdown = WCHeroCountdown;

  var WCStrikeBarCountdown = {
    _timer: null,
    init: function () {
      var bar = $(".wc-strike-now__cd-bar[data-end-time]");
      if (!bar) return;
      if (this._timer) clearInterval(this._timer);
      this._timer = bindCountdown(
        bar,
        bar.getAttribute("data-end-time"),
        ".wc-strike-now__cd-num",
      );
    },
  };
  window.WCStrikeBarCountdown = WCStrikeBarCountdown;

  /* ------------------------------------------------------------
   * WCEmptyHider — 隐藏未配置内容的 section（如未配 Firework embed code）
   * ------------------------------------------------------------ */
  function hideEmptySections() {
    // 隐藏 Firework section（当 desktop + mobile embed code 均空时）
    document
      .querySelectorAll(".firework-live-banner")
      .forEach(function (banner) {
        var placeholders = banner.querySelectorAll(
          ".firework-live-banner__placeholder",
        );
        var media = banner.querySelectorAll(".firework-live-banner__media");
        if (placeholders.length === media.length && media.length > 0) {
          // 所有 media 都是 placeholder → 完全没配置，隐藏整个 shopify-section 容器
          var section =
            banner.closest(".shopify-section") || banner.parentElement;
          if (section) section.style.display = "none";
        }
      });
  }

  /* ------------------------------------------------------------
   * WCFaq — Q&A 手风琴互斥展开（同一组内只保留一个 open）
   * ------------------------------------------------------------ */
  var WCFaq = {
    init: function () {
      $$("[data-wc-faq]").forEach(function (group) {
        var items = $$(".wc-faq__item", group);
        items.forEach(function (item) {
          item.addEventListener("toggle", function () {
            if (!item.open) return;
            items.forEach(function (other) {
              if (other !== item) other.removeAttribute("open");
            });
          });
        });
      });
    },
  };
  window.WCFaq = WCFaq;

  /* ------------------------------------------------------------
   * WCProdCard — 产品卡 Details show 展开/收起
   * ------------------------------------------------------------ */
  var WCProdCard = {
    init: function () {
      this._initLeadScroll();
    },
    _initLeadScroll: function () {
      $$(".wc-prod-card .as-lead-scroll").forEach(function (wrap) {
        var content = wrap.querySelector(".as-lead-scroll-content");
        var btn = wrap.querySelector(".as-lead-scroll-content-btn");
        if (!content || !btn || btn.dataset.wcLeadBound === "true") return;

        if (content.scrollHeight <= content.clientHeight) return;

        content.style.paddingRight = "24px";
        btn.classList.remove("d-none");
        btn.dataset.wcLeadBound = "true";

        function toggleDetails(e) {
          if (e) {
            e.preventDefault();
            e.stopPropagation();
          }
          content.classList.toggle("active");
          btn.classList.toggle("active");
        }

        btn.addEventListener("click", toggleDetails);
        btn.addEventListener("keydown", function (e) {
          if (e.key === "Enter" || e.key === " ") {
            toggleDetails(e);
          }
        });
      });
    },
  };
  window.WCProdCard = WCProdCard;

  /* ------------------------------------------------------------
   * Bootstrap
   * ------------------------------------------------------------ */
  function bootstrap() {
    try {
      hideEmptySections();
    } catch (e) {}
    try {
      WCHeroCountdown.init();
    } catch (e) {}
    try {
      WCStrikeNow.init();
    } catch (e) {}
    try {
      WCNav.init();
    } catch (e) {}
    try {
      WCBundle.init();
    } catch (e) {}
    try {
      WCRewards.init();
    } catch (e) {}
    try {
      WCProductSwiper.init();
    } catch (e) {}
    try {
      WCInfoCarousel.init();
    } catch (e) {}
    try {
      WCFaq.init();
    } catch (e) {}
    try {
      WCProdCard.init();
    } catch (e) {}
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootstrap);
  } else {
    bootstrap();
  }

  if (typeof Shopify !== "undefined" && Shopify.designMode) {
    document.addEventListener("shopify:section:load", function () {
      try {
        WCInfoCarousel._retryCount = 0;
        WCInfoCarousel.init();
      } catch (e) {}
      try {
        WCProductSwiper._retryCount = 0;
        WCProductSwiper.init();
      } catch (e) {}
    });
  }
})();
